<div id="offlineModal" class="offlineModal">
    <div class="modal-content">
        <div class = "div-center">
            <div id="smartText" class = "text-container">
                <div id="translateElement" #translateElement>Here we have some text</div>
            </div>
        </div>
        <div class="div-bottom">
            <table style="width: 100%; height: 1px; position: absolute; bottom: 0px;">
                <tr style="width: 100%; height: 100%;">
                    <td class="colClass">
                        <div style="height: 100%">
                            <button #ok class="button" (click)="closeOk($event)">
                                OK
                            </button>
                        </div>
                    </td>
                    <td class="colClass">
                        <div style="height: 100%">
                            <button #cancel class="button" (click)="close($event)">
                                Close
                            </button>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>

<div class="debug">
    <div id="mydiv1" class="mydiv">
        <div class="close" (click)="closeDiv($event)">&times;</div>
        <div class="mydivheader" (pointermove)="onMouseMove($event)" (pointerdown)="dragMouseDown($event)" (pointerup)="onMouseUp($event)">
            Click here to move
        </div>
        <input id="pingDelay" type="number" style="width:100px;"><br/>
        <button class="button2" (click)="pingAgain()">
            Ping Again
        </button><br/>
        <button class="button2" (click)="getPingText()">
            Ping Text
        </button><br/>
        <span>{{delayStr}}</span><br/>
        <button class="button2" (click)="saveLocation()">
            Save Location
        </button><br/>
        <button class="button2" (click)="saveLocationOffline()">
            Save Location Offline
        </button><br/>
        <span>{{timeStr}}</span><br/>
        <button class="button2" (click)="syncCoordinates()">
            Sync Coordinates
        </button><br/>
        <button class="button2" (click)="clearCacheCoords()">
            Clear Coordinates
        </button><br/>
        <button class="button2" (click)="open()">
            Display Modal
        </button><br/>
    </div>

    <div id="mydiv2" class="mydiv">
        <div class="close" (click)="closeDiv($event)">&times;</div>
        <div class="mydivheader" (pointermove)="onMouseMove($event)" (pointerdown)="dragMouseDown($event)" (pointerup)="onMouseUp($event)">Click here to move</div>
        <p>Moveable modal</p>
    </div>
</div>